import { getToken } from "firebase/messaging";
import { messaging } from "../../firebase";

const requestPermissionAndGetToken = async () => {
    try {
        const permission = await Notification.requestPermission();
        if (permission === "granted") {
            // Register service worker
            const registration = await navigator.serviceWorker.register(
                "/firebase-messaging-sw.js"
            );

            // Get FCM token with VAPID key
            const token = await getToken(messaging, {
                vapidKey:
                    "BLakNRnFgPS83mXGXbdFt5KELKlUnrekMxtCz5G6C0ffXW-CkKUfe-34ahUaQmnWR0e5q3RWheMR0aGWXysHxdo",
                serviceWorkerRegistration: registration,
            });

            if (token) {
                console.log("FCM Token", token);
                return token;
            } else {
                console.log("No FCM token available");
                return null;
            }
        } else {
            console.log("Notification permission not granted");
            return null;
        }
    } catch (error) {
        console.error("Error getting FCM token:", error);
        return null;
    }
};

export default requestPermissionAndGetToken;
